<template>
    <div id="component-loader-mini">
        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>    
    </div>
</template>

<script>
export default {
    name: "Loader_Mini",
    components: {
        
    },
    data: () => ({

    }),
    methods: {

    }
}
</script>